export default __webpack_public_path__ + "static/media/bg-map.af7d1b11.png";